import { createSlice } from "@reduxjs/toolkit";

const bannersSlice = createSlice({
  name: "banners",
  initialState: {
    top_banners: null,
    error: false,
    errorMessage: "",
  },
  reducers: {
    getAllHeroSectionSuccess: (state, action) => {
      state.top_banners = action.payload;
    },
    getAllPageHeaderSuccess: (state, action) => {
      state.page_header = action.payload;
    },
    getAllPageFooterSuccess: (state, action) => {
      state.page_footer = action.payload;
    }
  },
  selectors: {
    getTopBannersList: (state) => state.top_banners ?? [],
    getPageHeaderList: (state) => state.page_header ?? [],
    getPageFooterList: (state) => state.page_footer ?? []
  }
});

export const { getAllHeroSectionSuccess, getAllPageHeaderSuccess, getAllPageFooterSuccess } = bannersSlice.actions;

export const { getTopBannersList, getPageHeaderList, getPageFooterList } = bannersSlice.selectors;

export default bannersSlice.reducer;
